import { createSlice } from "@reduxjs/toolkit";
import { DashboardState, defaultFeatures, Feature, Features } from "types/dashboard";
import { fetchDashboardFeaturesThunk } from "./thunk";

const initialState: DashboardState = {
    features: {
        last_fetched_at: 0,
        items: null,
        loading: true,
        error: null,
        completed: false
    }
}

export const dashboardReducer = createSlice({
    name: "dashboard",
    initialState,
    extraReducers(builder) {
        builder.addCase(fetchDashboardFeaturesThunk.pending, (state) => {
            state.features.loading = true;
            state.features.error = null;
        })
        builder.addCase(fetchDashboardFeaturesThunk.fulfilled, (state, { payload }) => {
            state.features.loading = false;
            state.features.error = null;
            const { features, cached } = payload;
            let new_features = { ...defaultFeatures };

            for (let [key, value] of Object.entries(features ?? {})) {
                if (new_features.hasOwnProperty(key)) {
                    new_features[key as keyof Features] = {
                        ...new_features[key as keyof Features],
                        status: value.status ?? false,
                        ...(value.uuid ? {uuid: value.uuid} : {})
                    }
                }
            }

            state.features.items = new_features;
            if (!cached)
                state.features.last_fetched_at = Date.now();

            state.features.completed = Object.values((features ?? {})).every((f: Feature) => f.status === true);
        })
        builder.addCase(fetchDashboardFeaturesThunk.rejected, (state) => {
            state.features.loading = true;
            state.features.error = null;
        })
    },
    reducers: {
        markFeaturesDataStale: (state) => {
            if(state.features.completed) return;
            state.features.last_fetched_at = 0;
        }
    },
})

export const { markFeaturesDataStale } = dashboardReducer.actions;

export default dashboardReducer.reducer;